import { ImperialDistanceMeasurement } from "@/types/properties/ImperialDistanceMeasurement";
import { MetricDistanceMeasurement } from "@/types/properties/MetricDistanceMeasurement";

const convertMetresToFeetAndInchesString = (measurement: number) => {
  const imperialMeasurement = convertMetresToFeetAndInches(measurement);

  if (imperialMeasurement.feet > 0) {
    return `${imperialMeasurement.feet}'${imperialMeasurement.inches}"`;
  }

  return `${imperialMeasurement.inches}"`;
};

const convertMetresToFeetAndInches = (
  measurement: number,
): ImperialDistanceMeasurement => {
  let inches = Math.round((measurement * 100) / 2.54);
  let feet = 0;

  if (inches >= 12) {
    feet = Math.floor(inches / 12);
    inches %= 12;
  }

  return {
    feet: feet,
    inches: inches,
  };
};

const convertFeetToMetres = (feet: number, inches: number) => {
  const totalInches = feet * 12 + inches;

  const meters = (totalInches * 0.0254).toFixed(2);

  return Number(meters);
};

const convertMetresToMetresAndCentimetres = (
  metres: number,
): MetricDistanceMeasurement => {
  const measurementParts = metres.toString().split(".");

  return {
    metres: parseInt(measurementParts[0]),
    centimetres:
      measurementParts.length === 2
        ? parseInt(measurementParts[1].padEnd(2, "0"))
        : 0,
  };
};

const convertMetresAndCentimetresToMetres = (
  metres: number,
  centimetres: number,
) => {
  if (!centimetres || isNaN(centimetres)) {
    centimetres = 0;
  }

  return Number(`${metres}.${centimetres}`);
};

export {
  convertFeetToMetres,
  convertMetresToFeetAndInchesString,
  convertMetresToFeetAndInches,
  convertMetresToMetresAndCentimetres,
  convertMetresAndCentimetresToMetres,
};
